const childsMock = require('./childs.mock.json');
const guestsMock = require('./guests.mock.json');
const italianGuestsMock = require('./italianGuests.mock.json');
module.exports = { childsMock, guestsMock, italianGuestsMock };
